import {Pipe, PipeTransform} from '@angular/core';
import {DeviceType} from '@birco/rainmesh-api';
import {iconMap, IconName} from '../icons/icon-map';
import {FormConditionType} from '../../features/rules/enums/form-condition-type';

@Pipe({
  name: 'icons'
})
export class IconsPipe implements PipeTransform {

  transform(value: DeviceType | FormConditionType | IconName | string): IconName {
    if (value in iconMap) {
      return value as IconName
    }

    if (Object.values(DeviceType).includes(value as DeviceType)) {
      return this.getDeviceTypeIcon(value as DeviceType);
    }

    if (Object.values(FormConditionType).includes(value as FormConditionType)) {
      return this.getRuleConditionIcon(value as FormConditionType);
    }

    return 'ic_close';
  }

  getDeviceTypeIcon(deviceType: DeviceType): IconName {
    switch (deviceType) {
      case DeviceType.DISTANCE:
        return 'ic_distance';
      case DeviceType.FLOW:
        return 'ic_flow';
      case DeviceType.SOIL:
        return 'ic_water_percent';
      case DeviceType.VALVE:
        return 'ic_ventile';
      case DeviceType.PUMP:
        return 'ic_pump';
      case DeviceType.WEATHERSTATION:
        return 'ic_weatherstation';
      case DeviceType.UNKNOWN:
      default:
        return 'ic_unknown_device';
    }
  }

  getRuleConditionIcon(ruleConditionType: FormConditionType): IconName {
    switch (ruleConditionType) {
      case FormConditionType.weather:
        return 'ic_sun';
      case FormConditionType.clockTime:
        return 'ic_clock';
      case FormConditionType.soil:
        return 'ic_water_percent';
      case FormConditionType.cistern:
        return 'ic_cistern';
      default:
        return 'ic_close';
    }
  }

}
